import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

export default function useResetLocationChange(
  pathname,
  reduxConstant,
  fn,
  reduxReducer
) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname.includes(pathname)) {
        fn && fn();
        return null;
      } else {
        reduxConstant
          ? dispatch({ type: reduxConstant })
          : dispatch(reduxReducer());
      }
    });
  }, [history, dispatch, location, pathname, reduxConstant, reduxReducer, fn]);
}
